import { QuestelServicesClient, RequestResult, HttpMethodEnum } from '@questelservices/common';
import store from '@/store';
import { FileParseUploadDto } from '@/models/file-parsing/FileParseUploadDto';
import { LoadOptions } from 'devextreme/data/load_options';

export class FileParseUploadService {
  private client: QuestelServicesClient = new QuestelServicesClient(store, '/api/FileParseUploads');

  async getAll(): Promise<FileParseUploadDto[]> {
    return await this.client.get<FileParseUploadDto[]>('');
  }

  async get(FileParseUploadId: Guid): Promise<FileParseUploadDto> {
    return await this.client.get(`/status?fileParseUploadId=${FileParseUploadId}`);  
  }

  async search(options: LoadOptions) : Promise<any> {
    return await this.client.getPostData(`/search`, options);
  } 

  async submit(FileParseUploadId: Guid): Promise<any> {
    return await this.client.sendRequest(HttpMethodEnum.Patch, `/${FileParseUploadId}`);  
  }
}
